<template>
    <div class="dealer-item">
        <div class="dealer-item__inner" :style="{'borderColor': dealerItem.SegmentColor}">
            <div class="dealer-item__segments-wrap">
                <div class="dealer-item__segments" v-if="dealerItem.SegmentColors">
                    <span class="dealer-item__segment" v-for="(segmentColor, index) in dealerItem.SegmentColors" :style="{'backgroundColor': segmentColor}"></span>
                </div>
            </div>
            <div class="dealer-item__info">
                <div class="dealer-item__row" v-if="dealerItem.Description">
                    <p class="dealer-item__preheadline" v-html="dealerItem.Description"></p>
                </div>
                <div class="dealer-item__row">
                    <p class="dealer-item__headline">{{dealerItem.Name}}</p>
                    <p class="dealer-item__address" v-if="dealerItem.Address || (dealerItem.Zipcode || dealerItem.City) || dealerItem.Country">
                        <span class="dealer-item__address-row" v-if="dealerItem.Address">{{dealerItem.Address}}</span>
                        <span class="dealer-item__address-row" v-if="dealerItem.Zipcode || dealerItem.City">{{dealerItem.Zipcode}} {{dealerItem.City}}</span>
                        <span class="dealer-item__address-row" v-if="dealerItem.Country">{{dealerItem.Country}}</span>
                    </p>
                </div>
                <div class="dealer-item__row" v-if="dealerItem.Phone || dealerItem.Mobile || dealerItem.Fax || dealerItem.Email">
                    <p class="dealer-item__text" v-if="dealerItem.Phone">
                        {{dictionaries.DealerPhone}} <a :href="'tel:'+dealerItem.Phone" class="dealer-item__link">{{dealerItem.Phone}}</a>
                    </p>
                    <p class="dealer-item__text" v-if="dealerItem.Mobile">
                        {{dictionaries.DealerMobile}} <a :href="'tel:'+dealerItem.Mobile" class="dealer-item__link">{{dealerItem.Mobile}}</a>
                    </p>
                    <p class="dealer-item__text" v-if="dealerItem.Fax">
                        {{dictionaries.DealerFax}} <a :href="'tel:'+dealerItem.Fax" class="dealer-item__link">{{dealerItem.Fax}}</a>
                    </p>
                    <p class="dealer-item__text" v-if="dealerItem.Email">
                        {{dictionaries.DealerEmail}} <a :href="'mailto:'+dealerItem.Email" class="dealer-item__link">{{dealerItem.Email}}</a>
                    </p>
                </div>
                <div class="dealer-item__row" v-if="dealerItem.ExtraInfo">
                    <p class="dealer-item__text dealer-item__text--extra" v-html="dealerItem.ExtraInfo"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "dealerItem",
        props: ["dealerItem", "dictionaries"]
    };
</script>